import axios from 'axios';
import { getTenantSlug } from './api';

const API = process.env.REACT_APP_BACKEND_URL || '';

// Separate axios instance for member (üye) auth - uses member_token, never admin_token.
const memberApi = axios.create({
  baseURL: `${API}/api`,
});

memberApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('member_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.headers['X-Tenant-Slug'] = getTenantSlug();
  return config;
});

memberApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('member_token');
      const path = window.location.pathname;
      // Only auto-redirect from protected member areas
      if (path.startsWith('/profilim')) {
        window.location.href = '/uye/giris';
      }
    }
    return Promise.reject(err);
  }
);

export default memberApi;
